import { useState } from "react";

const testimonials = [
  {
    name: "影迷小王",
    avatar: "ri-user-3-line",
    rating: 5,
    comment: "蓝莓影院真的太棒了！画质清晰流畅，更新速度超快，而且完全免费，是我最爱的追剧平台！用了半年多了，从来没卡过，片源也特别全。",
    tag: "忠实用户",
  },
  {
    name: "动漫爱好者小李",
    avatar: "ri-user-3-line",
    rating: 5,
    comment: "动漫资源非常全，热门新番更新及时，播放流畅不卡顿，强烈推荐给所有动漫迷！日语原声和国配都能选，这个太贴心了。",
    tag: "动漫达人",
  },
  {
    name: "追剧达人阿琳",
    avatar: "ri-user-3-line",
    rating: 5,
    comment: "每天都在蓝莓影院追剧，分类清晰，找片方便，不用注册就能看，体验非常好。新剧上线速度比很多付费平台还快！",
    tag: "追剧狂人",
  },
  {
    name: "电影发烧友老张",
    avatar: "ri-user-3-line",
    rating: 4,
    comment: "电影资源很丰富，从经典老片到最新大片都有，画质不错，观影体验很好。尤其喜欢他们的专题推荐，总能发现好片。",
    tag: "电影爱好者",
  },
  {
    name: "综艺控小花",
    avatar: "ri-user-3-line",
    rating: 5,
    comment: "综艺节目更新很快，热门综艺都有，而且不需要付费，比很多平台都良心！每周末必刷，笑到停不下来。",
    tag: "综艺达人",
  },
  {
    name: "家庭用户陈先生",
    avatar: "ri-user-3-line",
    rating: 5,
    comment: "全家人都用蓝莓影院，老人看电视剧，孩子看动漫，我追综艺，一个平台满足全家人需求。最重要的是完全免费，省钱又省心。",
    tag: "家庭用户",
  },
];

export default function TestimonialSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="mb-6 text-center">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
          用户真实评价
        </h2>
        <p className="text-sm text-foreground-500 mt-1">来自千万影迷的真实反馈</p>
      </div>

      <div className="hidden md:grid md:grid-cols-3 gap-4 md:gap-5">
        {testimonials.map((item, idx) => (
          <div key={idx} className="p-5 rounded-xl bg-background-100">
            <div className="flex items-center gap-1 mb-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <i
                  key={i}
                  className={`ri-star-fill text-sm ${i < item.rating ? "text-accent-500" : "text-foreground-200"}`}
                ></i>
              ))}
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              "{item.comment}"
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className={`${item.avatar} text-secondary-500 text-sm`}></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">{item.name}</p>
                <p className="text-xs text-foreground-500">{item.tag}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="md:hidden">
        <div className="p-5 rounded-xl bg-background-100">
          <div className="flex items-center gap-1 mb-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <i
                key={i}
                className={`ri-star-fill text-sm ${i < testimonials[activeIndex].rating ? "text-accent-500" : "text-foreground-200"}`}
              ></i>
            ))}
          </div>
          <p className="text-sm text-foreground-700 leading-relaxed mb-4">
            "{testimonials[activeIndex].comment}"
          </p>
          <div className="flex items-center gap-3">
            <span className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
              <i className={`${testimonials[activeIndex].avatar} text-secondary-500 text-sm`}></i>
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-950">{testimonials[activeIndex].name}</p>
              <p className="text-xs text-foreground-500">{testimonials[activeIndex].tag}</p>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center gap-2 mt-4">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setActiveIndex(i)}
              className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                i === activeIndex ? "w-6 bg-primary-500" : "bg-foreground-300"
              }`}
              aria-label={`第 ${i + 1} 条评价`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}